/**
 * Hace que un <input type="date"> abra su calendario al hacer click en CUALQUIER parte
 * del campo, no sólo en el iconito de la derecha.
 *
 * El problema. En Chrome el calendario se despliega SÓLO si el click cae sobre ese ícono
 * —unos 20 píxeles—; en el resto del campo lo enfoca y no pasa nada más. Para quien lo
 * usa es indistinguible de un botón roto: hace click, no se abre, insiste, tampoco.
 *
 * Thiago lo reportó tres veces en pantallas distintas —filtros de Tickets (7-sep),
 * Solicitudes y Laboratorio (10-sep)— con la misma descripción: "apreté varias veces y
 * nada". En Tickets se arregló campo por campo, pero hay ~130 campos de fecha repartidos
 * en 50 archivos: parchearlos a mano es garantizar que se escapen varios, y que el
 * próximo que alguien agregue nazca roto.
 *
 * Por eso esto es UN listener delegado en document, instalado una vez. Cubre todos los
 * campos que existen y todos los que vengan, sin que nadie tenga que acordarse.
 *
 * showPicker() necesita una activación real del usuario, que el click provee. Si el
 * navegador no lo soporta o decide que no corresponde, se ignora: queda el
 * comportamiento de antes, nunca peor.
 */

let instalado = false;

export function installDatePickerOpener() {
  if (instalado || typeof document === 'undefined') return;
  instalado = true;

  document.addEventListener('click', (e) => {
    try {
      const el = e.target;
      if (!el || el.tagName !== 'INPUT') return;
      if (el.type !== 'date' && el.type !== 'datetime-local' && el.type !== 'month' && el.type !== 'time') return;
      if (el.disabled || el.readOnly) return;
      if (typeof el.showPicker !== 'function') return;
      el.showPicker();
    } catch {
      // Sin soporte, sin activación, o el navegador ya lo tenía abierto: da igual.
      // Un campo de fecha nunca puede romper la pantalla por intentar abrirse.
    }
  }, true);   // fase de captura: llega antes de que algún handler detenga el evento
}

/** Handler suelto, por si algún campo necesita el comportamiento sin el listener global. */
export function openPickerOnClick(e) {
  const el = e.currentTarget;
  if (!el || typeof el.showPicker !== 'function') return;
  try { el.showPicker(); } catch { /* ídem */ }
}

export default openPickerOnClick;

// Valor para un <input type="datetime-local"> en la hora LOCAL del navegador.
// `fecha.toISOString().slice(0, 16)` (o cortar el string que manda la API) da la hora
// en UTC, y el input la muestra como si fuera local: 3 horas corrida. Si ese valor se
// vuelve a guardar, cada edición suma otras 3 h. Pasó en Tareas de Campo, Laboratorio y
// Ticket Express (sep-2026). Acepta Date, string ISO o número; vacío → ''.
export function toLocalInputValue(fecha = new Date()) {
  if (fecha === null || fecha === undefined || fecha === '') return '';
  const d = fecha instanceof Date ? fecha : new Date(fecha);
  if (Number.isNaN(d.getTime())) return '';
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}
